export const formatDateFilter = (date) => {
  if (date == null) {
    return "";
  }
  date = new Date(date);
  if (Number.isNaN(date.getTime()) == true) {
    return "";
  } else {
    var day = date.getDate(),
      month = date.getMonth() + 1,
      year = date.getFullYear();
    day = day < 10 ? "0" + day : day;
    month = month < 10 ? "0" + month : month;
    return year + "-" + month + "-" + day;
  }
};

export const getNewDate = () => {
  var date = new Date();
  return formatDateFilter(date);
};

export const getThisMonth = () => {
  var date = new Date();
  var currentYear = date.getFullYear(),
    currentMonth = date.getMonth();
  var range = {};
  range.fromDate = new Date(currentYear, currentMonth, 1);
  range.toDate = new Date(currentYear, currentMonth + 1, 0);

  return range;
};

export const getMonthBefore = () => {
  var date = new Date();
  var month = date.getMonth() - 1;
  var getDate = new Date(date.setMonth(month));
  return formatDateFilter(getDate);
};

export const formatDate = (date) => {
  if (date == null) {
    return "";
  }
  date = new Date(date);
  if (Number.isNaN(date.getTime()) == true) {
    return "";
  } else {
    var day = date.getDate(),
      month = date.getMonth() + 1,
      year = date.getFullYear();
    day = day < 10 ? "0" + day : day;
    month = month < 10 ? "0" + month : month;
    return day + "/" + month + "/" + year;
  }
};
